import { checkRanges } from './check-ranges';
import { IScheduleWorkHours } from '../models';

export function scheduleIsInsideOtherSchedule(
  baseSchedule: IScheduleWorkHours[],
  scheduleForCheck: IScheduleWorkHours[],
): boolean {
  const invalidTimestamps = baseSchedule.filter(baseSchTimestamp => {
    const schTimestamp = scheduleForCheck.find(timestamp => baseSchTimestamp.day === timestamp.day);
    const closedValid = baseSchTimestamp.closed
      ? baseSchTimestamp.closed === schTimestamp.closed
      : true;

    if (!baseSchTimestamp.closed) {
      let hoursValid = true;
      const { baseRange: defaultSchBaseRange, additionalRange: defaultSchAdditionalRange } = baseSchTimestamp;
      const { baseRange, additionalRange } = schTimestamp;

      if (!schTimestamp.closed) {
        hoursValid = checkRanges(baseRange, defaultSchBaseRange);

        // if there is only additional range only in base schedule - check,
        // that current schedule range matches in base schedule ranges
        if (defaultSchAdditionalRange) {
          hoursValid = checkRanges(baseRange, defaultSchBaseRange) || checkRanges(baseRange, defaultSchAdditionalRange);
        }

        // if there is only additional range in current schedule - check,
        // that base schedule range matches in current schedule ranges
        if (additionalRange) {
          hoursValid = checkRanges(baseRange, defaultSchBaseRange) || checkRanges(additionalRange, defaultSchBaseRange);
        }

        if (defaultSchAdditionalRange && additionalRange) {
          hoursValid = checkRanges(baseRange, defaultSchBaseRange) && checkRanges(additionalRange, defaultSchAdditionalRange);
        }
      }

      return !(hoursValid && closedValid);
    }

    return !closedValid;
  });

  return !invalidTimestamps.length;
}
